"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInventory = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const graphql_1 = require("../graphql");
const common_1 = require("../helpers/common");
const useInventory = (params) => {
    const { validateCart } = params || {};
    const { cartItems, resolve, storeId } = (0, context_1.useNavbar)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [cartListMapping, setCartListMapping] = (0, react_1.useState)(null);
    const callGetInventory = async () => {
        try {
            setIsLoading(true);
            const inventoryPayload = cartItems === null || cartItems === void 0 ? void 0 : cartItems.map((product) => ({
                recordKey: product.recordKey,
                productId: product.id,
                variantId: product.variantId,
                source: product.cartItemSource || null,
            }));
            if (inventoryPayload.length) {
                const { data: { checkInventory: response }, } = await resolve(graphql_1.checkInventory, {
                    storeId,
                    items: inventoryPayload,
                });
                const mapping = response.reduce((acc, { price, inventory, recordKey, collections }) => (Object.assign(Object.assign({}, acc), { [recordKey]: { inventory, price, collections } })), {});
                setCartListMapping(mapping);
            }
            else {
                setCartListMapping({});
            }
            setIsLoading(false);
        }
        catch (_a) { }
    };
    (0, react_1.useEffect)(() => {
        callGetInventory();
    }, [cartItems]);
    const outOfStockItems = cartListMapping
        ? cartItems.filter((c) => { var _a; return Number(c.qty) > ((_a = cartListMapping[c.recordKey]) === null || _a === void 0 ? void 0 : _a.inventory); })
        : [];
    const inventoryMapping = cartListMapping
        ? Object.entries(cartListMapping).reduce((acc, [recordKey, { inventory }]) => (Object.assign(Object.assign({}, acc), { [recordKey]: inventory })), {})
        : {};
    const productWithUpdatedFieldValues = (0, react_1.useMemo)(() => {
        if (cartListMapping) {
            return Object.entries(cartListMapping).reduce((acc, [recordKey, { price, collections }]) => (Object.assign(Object.assign({}, acc), { [recordKey]: { price, collections } })), {});
        }
        return {};
    }, [cartListMapping, cartItems]);
    const isPriceMatch = (0, react_1.useMemo)(() => {
        return (!!cartListMapping &&
            cartItems.some((item) => cartListMapping[item.recordKey] &&
                Number(cartListMapping[item.recordKey].price) !== Number(item.price)));
    }, [cartListMapping, cartItems]);
    const isCollectionListChanged = (0, react_1.useMemo)(() => {
        return (!!cartListMapping &&
            cartItems.some((item) => {
                var _a;
                return (cartListMapping[item.recordKey] &&
                    (0, common_1.isDiffArray)(((_a = cartListMapping[item.recordKey]) === null || _a === void 0 ? void 0 : _a.collections) || [], (item === null || item === void 0 ? void 0 : item.collections) || []));
            }));
    }, [cartListMapping, cartItems]);
    (0, react_1.useEffect)(() => {
        if ((isPriceMatch || isCollectionListChanged) &&
            typeof validateCart === "function" &&
            !isLoading) {
            validateCart(productWithUpdatedFieldValues);
        }
    }, [isLoading, isPriceMatch, isCollectionListChanged]);
    return {
        ready: !!cartListMapping,
        success: !outOfStockItems.length && !isPriceMatch && !isLoading,
        outOfStockItems,
        inventoryMapping,
        productWithPrice: productWithUpdatedFieldValues,
    };
};
exports.useInventory = useInventory;
